import GuaranteedReservationAddCardContainer from './GuaranteedReservationAddCardContainer';

export default GuaranteedReservationAddCardContainer;
